const allowDynamicQuesFeature = () =>
	app.settings.global.packageLevel === app.packageLevels.premium;

export { allowDynamicQuesFeature };
